import GoogleAnalyticsHelper from './googleAnalyticsHelper';
import ActionTypes from '../../action-types';

const middleware = (store,) => (next,) => (action,) => {
  switch (action.type) {
    // Consumer Reviews and Ratings
    case ActionTypes.CLICK_CONSUMER_RATINGS_ACCORDION: {
      if (action.data.consumerRatingPanel.isOpen === true) {
        GoogleAnalyticsHelper.trackImpression(store.getState(), 'ratings');
      }

      next(action,);
      break;
    }

    case ActionTypes.CLICK_CONSUMER_REVIEWS_ACCORDION: {
      if (action.data.consumerReviewPanel.isOpen === true) {
        GoogleAnalyticsHelper.trackImpression(store.getState(), 'reviews');        
      }

      next(action,);
      break;
    }
    
    default:
      next(action,);
  }
};

export default middleware;
